/**
 * Full-size view of the architecture figure.
 *
 * Ported from the overlay markup (`public/index.html:559-562`) and its handlers
 * (`:565-597`): backdrop and close-button dismissal, Escape, and the body scroll
 * lock while it is open.
 */
import { useEffect } from 'react';

interface Props {
  src: string;
  onClose: () => void;
}

const ArchitectureLightbox = ({ src, onClose }: Props) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="lightbox-overlay active"
      id="lightbox"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <span className="lightbox-close" id="lightboxClose" onClick={onClose}>
        ×
      </span>
      <img
        className="lightbox-image"
        id="lightboxImage"
        src={src}
        alt="Enlarged view"
      />
    </div>
  );
};

export default ArchitectureLightbox;
